export const getTextClassNameByPersonType = (type: string) => {
    switch (type) {
        case "invited":
            return "text-arbo-yellow";
        case "child":
            return "text-arbo-green";
        case "adult":
        default:
            return "text-arbo-blue";
    }
};

export const getTextBackgroundClassNameByPersonType = (type: string) => {
    switch (type) {
        case "child":
            return "bg-arbo-green";
        case "adult":
        default:
            return "bg-arbo-blue";
    }
};
